import AccountCircleIcon from '@mui/icons-material/AccountCircleOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import EditIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteIconButton from '../../components/DeleteIconButton';
// import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates'; // unused
// import PlusOneIcon from '@mui/icons-material/PlusOne'; // unused
// import DeleteIcon from '@mui/icons-material/DeleteOutlined';
// import EditIcon from '@mui/icons-material/BorderColorOutlined';
import LinkIcon from '@mui/icons-material/Link';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, ClickAwayListener, Divider, Grid, IconButton, Link, Paper, Popper, Tooltip, Typography } from '@mui/material'; // Removed unused List, ListItem
import { makeStyles } from '@mui/styles';
// import { styled } from '@mui/material/styles'; // unused
import clsx from 'clsx';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types'; // Added for prop validation
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

import { CREATE, DataAPIContext, GET_ONE } from '../../api';
import useBatchDelete from '../../bg_tasks/useBatchDelete';
import EntityExportDialog from '../../components/EntityExportDialog';
import SelectAllBanner from '../../components/SelectAllBanner';
import useGridExport from '../../components/useGridExport';
import useSelectAll from '../../components/useSelectAll';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import FixedLinearProgress from '../../components/FixedLinearProgress';
import PageMeta from '../../components/PageMeta';
import RecordListPro from '../../components/RecordListPro'; // Changed import from RecordList
import { ContextStore } from '../../store/contextStore';
import { copyTextToClipboard, useIsWidthUp } from '../../utils';
import { ConfirmationUserDialogText, formatNewUserManagerPushURL } from '../utils';
import AddTripUser from './AddTripUser';
import { applyTicketChanges, hasTicketChanges } from './ticketChanges';
import BatchActionsMenu from './BatchActionsMenu';
import BatchChangeBookingOwnerDialog from './BatchChangeBookingOwnerDialog';
import TripUserColumnsPanel from './TripUserColumnsPanel';
import { checkoutPickerMoment } from './checkoutTime';
import { DateCell, RolesCell, TagCell } from './CustomRecordListCells';
import DateRangeFilterPanel from './DateRangeFilterPanel';
import TripUserPreview from './TripUserEdit';
import useInvitationLinkWatch from './useInvitationLinkWatch';
import { checkinSourceFilterOptions, serverTextOperators } from './gridFilters';
// import TripUserListItem from './TripUserListItem'; // Removed unused import
import { LOCATION_STATUS, formatLatestAppVersionsDisplay } from '../../users/utils';
import UserListToolbar from './UserListToolbar';
import { BOOKING_STATE_BOOKED, BOOKING_STATES, CHECKIN_SOURCES, PRECHECKIN_STATUSES, SOURCES, SURVEY_STATES, precheckinStatusesOptions } from './utils';
// import { grey } from '@mui/material/colors'; // unused
// import LightTooltip from '../../components/LightTooltip'; // unused
import AccessGroupsGridCell from '../../components/AccessGroupsGridCell';

const useStyles = makeStyles((theme) => ({
    root: {
        border: 'solid 1px #D8D8D8',
        borderRadius: '0 0 12px 12px',
        marginBottom: '1rem',
        backgroundColor: theme.palette.background.paper,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 0,
            border: 'none',
        },
    },
    recordListWrapper: {
        height: `calc(${theme.cp.contentHeight} - 10rem) !important`,
        [theme.breakpoints.down('sm')]: {
            height: `100% !important`,
            marginTop: '-0.5rem !important',
        },
    },
    // Fixed-page layout (CP-8237): the tab fills the space under the back bar
    // and tabs (~6.7rem) plus the root's own bottom margin, the toolbar keeps
    // its natural height, and only the record list scrolls — like the Trips
    // list and Trip Items pages.
    rootFixedLayout: {
        display: 'flex',
        flexDirection: 'column',
        height: `calc(${theme.cp.contentHeight} - 8rem)`,
        overflow: 'hidden',
    },
    listRowFixedLayout: {
        flex: '1 1 auto',
        minHeight: 0,
    },
    recordListWrapperFixedLayout: {
        height: '100% !important',
    },
    recordList: {
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
    },
    addFormRoot: {
        maxWidth: '40vw',
        padding: '1rem',

        [theme.breakpoints.down('sm')]: {
            maxWidth: '99vw',
        },
    },
    addTripUserPaperWrapper: {
        marginRight: '1rem',
        marginTop: '0.5rem',

        [theme.breakpoints.down('sm')]: {
            margin: 0,
        },
    },
    listItem: {
        width: '95vw',
    },
}));


const formatDateFilters = (dateStartFilter, dateEndFilter) => {
    if (dateStartFilter && !dateEndFilter) {
        return dateStartFilter;
    }
    if (dateEndFilter && !dateStartFilter) {
        return dateEndFilter;
    }
    if (dateStartFilter && dateEndFilter) {
        return [dateStartFilter, dateEndFilter];
    }
};

const checkIfURLDataIsUserId = (data) => {
    if (data?.user_id) {
        const userId = parseInt(data.user_id);
        return !isNaN(userId) ? userId : null;
    }
    //RouteParams data can include either user_id, api_filter or both, if user_id is provided without api_filters then user.id will be returned
    try {
        const apiFilters = parseInt(data.api_filters);
        return !isNaN(apiFilters) ? apiFilters : null;
    } catch {
        return null;
    }
};

const buildDefaultColumnVisibilityModel = (isBespoke, agroupsEnabled) => ({
    date: !isBespoke,
    deep_link: false,
    order_ref: false,
    custom_id: false,
    affiliate_ext_id: false,
    voucher: true,
    supplier_ref: false,
    reseller_ref: false,
    departure: false,
    departure_key: false,
    people_count: false,
    passenger_breakdown: false,
    pickup_time: false,
    lang: false,
    int_ids: false,
    booking_state: false,
    main_booking: false,
    create_source: false,
    update_source: false,
    is_app_installed: false,
    location_status: false,
    notifications_status: false,
    latest_position: false,
    role: !agroupsEnabled,
    agroups: agroupsEnabled,
    created_ts: false,
    updated_ts: false,
    booking_ts: false,
    checkin_source: false,
    mytrips_display: false,
    exclude_from_chat: false,
    exclude_from_group_chat: false,
    integration: false,
    survey_state: false,
});

const getMobileRoleChipProps = (row, roleMap) => {
    const user = row?.user;
    if (!user) {
        return null;
    }
    if (user.roles && user.roles.length > 0 && roleMap[user.roles[0]]) {
        return { label: roleMap[user.roles[0]].name };
    }
    if (user.agroups && user.agroups.some((agroup) => agroup.is_guest_group || agroup.name === 'Guests')) {
        return { label: 'Guest' };
    }
    return null;
};

const GroupedMobileUserRow = (props) => {
    const { row, idx, rowsLength, onRemoveUserFromTrip, searchFilterList, recordListFilters, trip, setTourUserId, history, roleMap } = props;
    const [expanded, setExpanded] = React.useState(false);

    if (row?._mobileHiddenOnList) {
        return null;
    }

    const renderActions = (bookingRow) => (
        <Grid item xs={12} container justifyContent="flex-start" spacing={0.5} alignItems="center" sx={{ ml: '-6px' }}>
            <Grid item>
                <Tooltip title="View user profile">
                    <IconButton onClick={() => history.push(`/user/${bookingRow.user.id}`)} aria-label="User profile" size="small">
                        <AccountCircleIcon fontSize="small" color="primary" />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip title="Edit user info">
                    <Link
                        href={formatNewUserManagerPushURL(searchFilterList, recordListFilters, trip.id, bookingRow.id)}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            history.push(formatNewUserManagerPushURL(searchFilterList, recordListFilters, trip.id, bookingRow.id));
                            setTourUserId(null);
                            setTimeout(() => {
                                setTourUserId(bookingRow.id);
                            }, 100);
                        }}
                    >
                        <EditIcon fontSize="small" color="primary" />
                    </Link>
                </Tooltip>
            </Grid>
            {bookingRow.branchio_link && (
                <Grid item>
                    <Tooltip title="Copy invitation link">
                        <IconButton onClick={() => copyTextToClipboard(bookingRow.branchio_link)} aria-label="Copy invitation link" size="small">
                            <LinkIcon fontSize="small" color="primary" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            )}
            <Grid item>
                <DeleteIconButton
                    title="Remove user from trip"
                    perm="tour_participant.delete"
                    onClick={() => onRemoveUserFromTrip && onRemoveUserFromTrip(bookingRow.id)}
                />
            </Grid>
        </Grid>
    );

    const renderBooking = (bookingRow, isChild = false) => {
        const chip = getMobileRoleChipProps(bookingRow, roleMap);
        return (
            <Grid container spacing={1} p={2} alignItems="center" sx={isChild ? { pl: 5 } : undefined}>
                <Grid item xs={12} container spacing={1} alignItems="center" wrap="nowrap">
                    <Grid item xs style={{ minWidth: 0 }}>
                        <Typography style={{ wordWrap: 'break-word', whiteSpace: 'normal' }} noWrap title={bookingRow.user?.display_name || bookingRow.user?.email || 'N/A'}>
                            {bookingRow.user?.display_name || bookingRow.user?.email || 'N/A'}
                        </Typography>
                    </Grid>
                    {chip && (
                        <Grid item>
                            <Chip size="small" label={chip.label} sx={{ borderRadius: '4px' }} />
                        </Grid>
                    )}
                </Grid>
                {bookingRow.user?.email && (
                    <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" noWrap title={bookingRow.user.email}>
                            {bookingRow.user.email}
                        </Typography>
                    </Grid>
                )}
                {bookingRow.user?.phone && (
                    <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" noWrap title={bookingRow.user.phone}>
                            {bookingRow.user.phone}
                        </Typography>
                    </Grid>
                )}
                {renderActions(bookingRow)}
            </Grid>
        );
    };

    const childRows = row._mobileSubbookings || [];
    const hasChildren = childRows.length > 0;

    return (
        <>
            <Box>
                <Box onClick={() => hasChildren && setExpanded((prev) => !prev)} sx={{ cursor: hasChildren ? 'pointer' : 'default' }}>
                    <Grid container spacing={1} p={2} alignItems="center">
                        <Grid item xs={12} container spacing={1} alignItems="center" wrap="nowrap">
                            {hasChildren ? (
                                <Grid item>
                                    {expanded ? <ExpandMoreIcon sx={{ color: '#666666' }} /> : <ChevronRightIcon sx={{ color: '#666666' }} />}
                                </Grid>
                            ) : null}
                            <Grid item xs style={{ minWidth: 0 }}>
                                <Typography style={{ wordWrap: 'break-word', whiteSpace: 'normal' }} noWrap title={row.user?.display_name || row.user?.email || 'N/A'}>
                                    {row.user?.display_name || row.user?.email || 'N/A'}{hasChildren ? ` (+${childRows.length})` : ''}
                                </Typography>
                            </Grid>
                            {getMobileRoleChipProps(row, roleMap) && (
                                <Grid item>
                                    <Chip size="small" label={getMobileRoleChipProps(row, roleMap).label} sx={{ borderRadius: '4px' }} />
                                </Grid>
                            )}
                        </Grid>
                        {row.user?.email && (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" noWrap title={row.user.email}>
                                    {row.user.email}
                                </Typography>
                            </Grid>
                        )}
                        {row.user?.phone && (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" noWrap title={row.user.phone}>
                                    {row.user.phone}
                                </Typography>
                            </Grid>
                        )}
                        {renderActions(row)}
                    </Grid>
                </Box>
                {expanded && childRows.length > 0 && (
                    <Box>
                        <Divider />
                        {childRows.map((childRow, childIdx) => (
                            <React.Fragment key={childRow.id}>
                                {renderBooking(childRow, true)}
                                {childIdx < childRows.length - 1 ? <Divider /> : null}
                            </React.Fragment>
                        ))}
                    </Box>
                )}
            </Box>
            {idx < rowsLength - 1 ? <Divider /> : null}
        </>
    );
};

GroupedMobileUserRow.propTypes = {
    row: PropTypes.object.isRequired,
    idx: PropTypes.number.isRequired,
    rowsLength: PropTypes.number.isRequired,
    hasPerm: PropTypes.func.isRequired,
    onRemoveUserFromTrip: PropTypes.func,
    searchFilterList: PropTypes.array,
    recordListFilters: PropTypes.object,
    trip: PropTypes.object,
    setTourUserId: PropTypes.func,
    history: PropTypes.object,
    roleMap: PropTypes.object.isRequired,
};

export const UserManager = (props) => {
    const history = useHistory();
    const dataAPI = React.useContext(DataAPIContext);
    const resource = 'tour_user';
    const { /* settings, */ roles, roleMap, hasPerm, accessGroupsEnabled, finalizeLogin } = React.useContext(ContextStore); // Removed unused settings
    const classes = useStyles();
    const [tourUserRoles, /*setTourUserRoles*/] = React.useState([{ id: null, name: 'Guest' }, ...roles]); // unused variable setTourUserRoles
    const [syncActive, setSyncActive] = React.useState(false);
    const [lastUpdate, _setLastUpdate] = React.useState(null); // Renamed original setter
    const [relatedLoading, setRelatedLoading] = React.useState(false);
    const [pageReset, setPageReset] = React.useState(false);
    
   
    const { enqueueSnackbar } = useSnackbar();
    const isSmallScreen = !useIsWidthUp('sm');
    const [confirmationDialogAction, setConfirmationDialogAction] = React.useState(null);
    const [resetGridLayoutDialogOpen, setResetGridLayoutDialogOpen] = React.useState(false);
    
    // CP-8376: Check-out exists on the grid only when a booking on this tour owns
    // its checkout. The tour flag covers the page load; this catches a checkout
    // saved in the current session before the trip payload is fetched again.
    const [ownCheckoutSeen, setOwnCheckoutSeen] = React.useState(false);
    React.useEffect(() => {
        setOwnCheckoutSeen(false);
    }, [props.trip.id]);
    const showCheckoutColumn = !!props.trip.has_own_checkout || ownCheckoutSeen;

    const [idsToDelete, setIdsToDelete] = React.useState([]);
    const [numberOfTourUsers, setNumberOfTourUsers] = React.useState(props.trip.user_stats ? props.trip.user_stats : { total: 0, null: 0 });

    const routeParams = useParams();
    const routeParamsAPIFilters = routeParams.api_filters && routeParams.api_filters !== 'user_preview' ? JSON.parse(routeParams.api_filters) : {};
    const [tourUserId, setTourUserId] = React.useState(checkIfURLDataIsUserId(routeParams));
    
    const [searchFilterList, setSearchFilterList] = React.useState(routeParamsAPIFilters?.searchFilterList || []);
    // Revert recordListFilters initialization
    const [recordListFilters, setRecordListFilters] = React.useState({
        bookingState: BOOKING_STATE_BOOKED,
        agroups: null,
        groupByMainBooking: false,
        ...(routeParamsAPIFilters?.recordListFilters || {}),
    });
    const [recordListQuery, setRecordListQuery] = React.useState(null);

    const [showActionForm, setShowActionForm] = React.useState(false);
    const [batchActionType, setBatchActionType] = React.useState('');

    const [addUserAnchorEl, setAddUserAnchorEl] = React.useState(null);
    const [addUserFlowOpen, setAddUserFlowOpen] = React.useState(
        () => new URLSearchParams(window.location.search).get('addingUser') === 'true'
    );

    React.useEffect(() => {
        const unlisten = history.listen((loc) => {
            if (new URLSearchParams(loc.search).get('addingUser') !== 'true') {
                setAddUserFlowOpen(false);
                setAddUserAnchorEl(null);
            }
        });
        return unlisten;
    }, [history]);

    // const imageHeight = 48; // Unused variable
    // const imageWidth = 48; // Unused variable

    const roles_data = roles;

    const cols = isSmallScreen ? (tourUserId ? 0 : 12) : tourUserId ? 8 : 12;
    // Desktop-only, and only while the user preview panel is closed — with it
    // open the preview needs the page scroll (and the fixed buttons hide).
    const fixedListLayout = !isSmallScreen && !tourUserId;

    const [selectedUserToDeleteDetails, setSelectedUserToDeleteDetails] = React.useState();

    // Persist and control column visibility to avoid reset on filtering/searching
    const COLUMN_VIS_KEY = 'TripUserManager.columnVisibilityModel';
    // v2: stores { field: number } — plain px values, no nested objects
    const COLUMN_WIDTHS_KEY = 'TripUserManager.columnWidths.v2';
    const COLUMN_ORDER_KEY = 'TripUserManager.columnOrder.v2';
    const LEGACY_COLUMN_ORDER_GROUPED_KEY = 'TripUserManager.columnOrder.v2.grouped';
    // DataGridPro tree grouping column — not part of shared order; pinned in grouped view
    const GROUPING_COLUMN_FIELD = '__tree_data_group__';
    const SORT_MODEL_KEY = 'TripUserManager.sortModel.v2';
    const DEFAULT_SORT_MODEL = [{ field: 'id', sort: 'asc' }];
    const initialColumnVisibilityModel = React.useMemo(() => {
        try {
            const saved = localStorage.getItem(COLUMN_VIS_KEY);
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (e) {
            // Ignore localStorage parsing errors
        }
        return buildDefaultColumnVisibilityModel(props.trip.is_bespoke, accessGroupsEnabled());
    }, [props.trip.is_bespoke, accessGroupsEnabled]);

    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState(initialColumnVisibilityModel);

    const onColumnVisibilityModelChange = React.useCallback((model) => {
        setColumnVisibilityModel(model);
        try {
            localStorage.setItem(COLUMN_VIS_KEY, JSON.stringify(model));
        } catch (e) {
            // Ignore localStorage errors
        }
    }, []);

    // columnWidths: { [field]: number } — kept in state so columns rebuild with correct widths
    // on any re-render (filter change, context update, groupBy toggle, etc.)
    const [columnWidths, setColumnWidths] = React.useState(() => {
        try {
            const raw = JSON.parse(localStorage.getItem(COLUMN_WIDTHS_KEY) || '{}');
            // Validate: only keep plain finite numbers
            const clean = {};
            for (const [k, v] of Object.entries(raw)) {
                if (typeof v === 'number' && Number.isFinite(v)) clean[k] = v;
            }
            return clean;
        } catch { return {}; }
    });

    const onColumnWidthChange = React.useCallback((params) => {
        const width = params.width;
        if (!Number.isFinite(width)) return;
        setColumnWidths((prev) => {
            const next = { ...prev, [params.colDef.field]: width };
            try { localStorage.setItem(COLUMN_WIDTHS_KEY, JSON.stringify(next)); } catch {}
            return next;
        });
    }, []);

    const [sortModel, setSortModel] = React.useState(() => {
        try {
            const raw = JSON.parse(localStorage.getItem(SORT_MODEL_KEY) || 'null');
            if (Array.isArray(raw) && raw.length > 0 && raw.every((i) => i?.field && (i.sort === 'asc' || i.sort === 'desc'))) {
                return raw;
            }
        } catch {}
        return DEFAULT_SORT_MODEL;
    });

    const onSortModelChange = React.useCallback((model) => {
        const next = (model || []).filter((item) => item?.field && (item.sort === 'asc' || item.sort === 'desc'));
        const normalized = next.length ? next : DEFAULT_SORT_MODEL;
        setSortModel(normalized);
        try { localStorage.setItem(SORT_MODEL_KEY, JSON.stringify(normalized)); } catch {}
    }, []);

    const sanitizeColumnOrder = (order) => (
        (order || []).filter((field) => (
            typeof field === 'string'
            && field !== GROUPING_COLUMN_FIELD
            && !field.startsWith('__tree_data_group__')
        ))
    );

    const [columnOrder, setColumnOrder] = React.useState(() => {
        try {
            let raw = JSON.parse(localStorage.getItem(COLUMN_ORDER_KEY) || '[]');
            if (!Array.isArray(raw) || raw.length === 0) {
                raw = JSON.parse(localStorage.getItem(LEGACY_COLUMN_ORDER_GROUPED_KEY) || '[]');
            }
            return sanitizeColumnOrder(raw);
        } catch {
            return [];
        }
    });

    const confirmResetGridLayout = React.useCallback(() => {
        const defaults = buildDefaultColumnVisibilityModel(props.trip.is_bespoke, accessGroupsEnabled());
        setColumnVisibilityModel(defaults);
        setColumnWidths({});
        setColumnOrder([]);
        setSortModel(DEFAULT_SORT_MODEL);
        try {
            localStorage.removeItem(COLUMN_VIS_KEY);
            localStorage.removeItem(COLUMN_WIDTHS_KEY);
            localStorage.removeItem(COLUMN_ORDER_KEY);
            localStorage.removeItem(SORT_MODEL_KEY);
            localStorage.removeItem(LEGACY_COLUMN_ORDER_GROUPED_KEY);
        } catch {}
        setResetGridLayoutDialogOpen(false);
    }, [props.trip.is_bespoke, accessGroupsEnabled]);

    const replaceUserManagerPathPreservingGridPagination = React.useCallback((path) => {
        const existing = new URLSearchParams(history.location.search);
        const next = new URLSearchParams();
        const page = existing.get('page');
        const pageSize = existing.get('pageSize');
        if (page) next.set('page', page);
        if (pageSize) next.set('pageSize', pageSize);
        const qs = next.toString();
        history.replace(qs ? `${path}?${qs}` : path);
    }, [history]);

    const locationOptions = React.useMemo(() => Object.keys(LOCATION_STATUS).map((x) => ({ value: +x, label: LOCATION_STATUS[x] })), []);
    // const roleOptions = React.useMemo(() => Object.keys(roleMap).map((x) => ({ value: +x, label: roleMap[x].name })), [roleMap]); // Unused variable
    const notificationsOptions = React.useMemo(() => [
        { value: true, label: 'Enabled' },
        { value: false, label: 'Disabled' },
    ], []);
    const checkinSourceOptions = React.useMemo(checkinSourceFilterOptions, []);
    const textFilterOperators = React.useMemo(serverTextOperators, []);
    const registrationMethods = React.useMemo(() => Object.keys(SOURCES).map((x) => ({ value: +x, label: SOURCES[x] })), []);
    const surveyStateOptions = React.useMemo(() => Object.keys(SURVEY_STATES).map((x) => ({ value: +x, label: SURVEY_STATES[x] })), []);
    const dateFilters = React.useMemo(
        () => formatDateFilters(recordListFilters.dateStartFilter, recordListFilters.dateEndFilter),
        [recordListFilters.dateStartFilter, recordListFilters.dateEndFilter]
    );
    const isGroupedByMainBooking = !!recordListFilters.groupByMainBooking;

    const recordListExtraQueryParams = React.useMemo(() => (
        isGroupedByMainBooking ? { view: 'list', group_by: 'main_booking' } : { view: 'list' }
    ), [isGroupedByMainBooking]);

    const transformRecordListRows = React.useCallback((rows) => {
        if (!isGroupedByMainBooking) {
            return rows;
        }
        const flattenedRows = [];
        (rows || []).forEach((mainBooking) => {
            const subbookings = mainBooking.subbookings || [];
            const mainLabel = `${mainBooking.user?.display_name || mainBooking.id}::${mainBooking.id}`;
            flattenedRows.push({
                ...mainBooking,
                _treePath: [mainLabel],
                _isGroupMain: true,
                _mobileSubbookings: subbookings,
            });
            subbookings.forEach((subbooking) => {
                const subLabel = `${subbooking.user?.display_name || subbooking.id}::${subbooking.id}`;
                flattenedRows.push({
                    ...subbooking,
                    _treePath: [mainLabel, subLabel],
                    _isGroupMain: false,
                    _groupMainId: mainBooking.id,
                    _mobileHiddenOnList: true,
                });
            });
        });
        return flattenedRows;
    }, [isGroupedByMainBooking]);

    const groupedTreeColumn = React.useMemo(() => ({
        field: GROUPING_COLUMN_FIELD,
        headerName: 'Booking group',
        minWidth: 220,
        flex: 0.8,
        hideDescendantCount: true,
        valueFormatter: (params) => {
            const label = String(params.value || '').split('::')[0];
            const row = params.api?.getRow?.(params.id) || params.row;
            const subbookingsCount = row?._isGroupMain ? (row?.subbookings_count || 0) : 0;
            return subbookingsCount > 0 ? `${label} (+${subbookingsCount})` : label;
        },
    }), []);

    const departureTimeRange = React.useMemo(() => {
        const start = recordListFilters.departureTimeStart || null;
        const end = recordListFilters.departureTimeEnd || null;
        if (start || end) {
            return [start, end];
        }
        return undefined;
    }, [recordListFilters.departureTimeStart, recordListFilters.departureTimeEnd]);

    // Memoize apiFilters array creation using specific filter values as dependencies
    const computedApiFilters = React.useMemo(() => {
        const filters = [
            { field: 'tag_ids', value: recordListFilters.tagSearchFilters?.toString() },
            { field: 'exclude_tag_ids', value: recordListFilters.tagExcludeFilters?.toString() },
            { field: 'user_ids', value: recordListFilters.userSearchFilters?.toString() },
            { field: 'date', value: dateFilters },
            { field: 'role', value: recordListFilters.roleFilter ? recordListFilters.roleFilter.toString() : '' },
            { field: 'agroups', value: (recordListFilters.agroups || []).map(x => x.id) },
            { field: 'booking_state', value: recordListFilters.bookingState?.toString() },
        ];
        if (departureTimeRange) {
            filters.push({ field: 'departure_time_range', value: departureTimeRange });
        }
        return filters;
    },
        [
            recordListFilters.tagSearchFilters,
            recordListFilters.tagExcludeFilters,
            recordListFilters.userSearchFilters,
            dateFilters, // Already memoized based on dateStartFilter/dateEndFilter
            recordListFilters.roleFilter,
            recordListFilters.agroups,
            recordListFilters.bookingState,
            departureTimeRange
        ]);

    const [apiFiltersForRecordList, setApiFiltersForRecordList] = React.useState(computedApiFilters);

    React.useEffect(() => {
        if (!relatedLoading) {
            if (JSON.stringify(computedApiFilters) !== JSON.stringify(apiFiltersForRecordList)) {
                setApiFiltersForRecordList(computedApiFilters);
            }
        }
    }, [computedApiFilters, relatedLoading, apiFiltersForRecordList]);

    const selectAllExtraParams = React.useMemo(() => {
        const p = { tour_id: props.trip.id, view: 'list' };
        if (isGroupedByMainBooking) p.group_by = 'main_booking';
        return p;
    }, [props.trip.id, isGroupedByMainBooking]);

    const {
        selectedIds, setSelectedIds,
        selectAll, deselectAll,
        selectAllMeta, loading: selectAllLoading,
    } = useSelectAll({
        resource,
        apiFilters: apiFiltersForRecordList,
        query: recordListQuery,
        extraParams: selectAllExtraParams,
    });

    // XML/JSON entity export of this tour's bookings (import-compatible format,
    // grouped under a <tour> association wrapper server-side).
    const [bookingExportOpen, setBookingExportOpen] = React.useState(false);
    const [bookingExportFormat, setBookingExportFormat] = React.useState(null);
    const openBookingExport = (format) => {
        setBookingExportFormat(typeof format === 'string' ? format : null);
        setBookingExportOpen(true);
    };
    const { exportDocument: exportBookingDocument, exporting: bookingExporting } = useGridExport({
        resource,
        apiFilters: apiFiltersForRecordList,
        query: recordListQuery,
        extraParams: selectAllExtraParams,
        selectedIds,
        isAllSelected: false,
    });

    React.useEffect(() => {
        if (isGroupedByMainBooking && columnVisibilityModel.main_booking !== false) {
            onColumnVisibilityModelChange({ ...columnVisibilityModel, main_booking: false });
        }
    }, [columnVisibilityModel, isGroupedByMainBooking, onColumnVisibilityModelChange]);

    // Guarded setLastUpdate function - prevents list refresh while operations are in progress
    const setLastUpdate = React.useCallback((newValue) => {
        if (!relatedLoading) {
            _setLastUpdate(newValue);
        }
    }, [relatedLoading, _setLastUpdate]); // Added _setLastUpdate to dependencies

    // CP-8331: a new booking's invitation link is created a few seconds after the booking;
    // refresh the grid once it exists so the copy-link icon works without a page reload.
    const { watch: watchInvitationLink } = useInvitationLinkWatch({
        resource,
        onReady: () => setLastUpdate(Date.now()),
    });

    // CP-7771: the delete runs as a background task. The grid and the counts refresh once it has finished;
    // refreshed when it started, the deleted users stayed listed and were deleted again ("Delete 0").
    const { deleteRecords } = useBatchDelete({
        resource,
        names: ['trip user', 'trip users'],
        onDeleted: () => {
            setLastUpdate(Date.now());
            doUpdateUserList().then(updateNumberOfTourUsers);
        },
    });

    const doDeleteUserList = async (idlist) => {
        setSyncActive(true);
        setRelatedLoading(true);
        const accepted = await deleteRecords(idlist);
        if (accepted) {
            setIdsToDelete(null);
            setSelectedIds([]);
        }
        setSyncActive(false);
        setRelatedLoading(false);
        setSelectedUserToDeleteDetails({});
        setTourUserId(null); // Ensure list is visible in mobile after deletion
    };

    const doUpdateUserList = () => {
        return new Promise((resolve) => {
            dataAPI(GET_ONE, 'tour', { id: props.trip.id })
                .then(res => {
                    if (res.statusCode === 200 || res.statusCode === 204) {
                        resolve(res.data.user_stats ? res.data.user_stats : { total: 0, null: 0 });
                    } else if (res.statusCode >= 400) {
                        enqueueSnackbar('Error updating user list count', { variant: 'error' });
                        resolve({ total: 0, null: 0 });
                    } else {
                        enqueueSnackbar('Unexpected HTTP status: ' + res.statusCode, { variant: 'error' });
                        resolve({ total: 0, null: 0 });
                    }
                })
                .catch(error => {
                    console.error("Error in doUpdateUserList:", error);
                    enqueueSnackbar('Error updating user list count', { variant: 'error' });
                    resolve({ total: 0, null: 0 });
                });
        });
    };


    const onDeleteUserList = (idlist, user) => {
        if (user) {
            setSelectedUserToDeleteDetails(user);
        }
        setIdsToDelete(idlist);
        setConfirmationDialogAction(idlist.length > 1 ? 'delete_users' : 'delete_user');
    };

    // listItemRenderer is not needed for RecordListPro with DataGridPro


    const confirmationDialogCancel = () => {
        setConfirmationDialogAction(null);
    };

    const confirmationDialogConfirm = () => {
        switch (confirmationDialogAction) {
            case 'delete_user':
            case 'delete_users':
                doDeleteUserList(idsToDelete);
                setTourUserId(null); // Ensure list is visible in mobile after deletion
                break;
            default:
                break;
        }
        confirmationDialogCancel();
    };

    // Revert updateNumberOfTourUsers useCallback
    const updateNumberOfTourUsers = (data) => {
        if (data && JSON.stringify(data) !== JSON.stringify(numberOfTourUsers)) {
            setNumberOfTourUsers(data);
        }
    };


    const saveChanges = async (tour_user_with_tickets) => {
        setSyncActive(true);
        setRelatedLoading(true);
        // CP-5799: tickets picked in the form are added once the user exists (their own routes).
        const { _ticketChanges, ...tour_user } = tour_user_with_tickets;
        let params = props.trip.is_bespoke
            ? {
                data: { ...tour_user, tour_id: props.trip.id },
                upload: true,
            }
            : {
                date: tour_user.date,
                data: { ...tour_user, tour_id: props.trip.id },
                upload: true,
            };

        // Revert optional chaining/checks for attachments/voucher
        if (params.data.attachments.length > 0) {
            for (let index = 0; index < params.data.attachments.length; index++) {
                params.data.attachments[index] = params.data.attachments[index].file;
            }
        }
        if (params.data.voucher) {
            params.data.voucher = params.data.voucher.file;
        }

        if (params.data.departure) {
            params.data.tags = [...params.data.tags, params.data.departure.tag];
        }
        const res = await dataAPI(CREATE, resource, params);
        if (res.statusCode === 200 || res.statusCode === 201) {
            enqueueSnackbar('User added', { variant: 'success' });
            if (hasTicketChanges(_ticketChanges) && res.data?.id) {
                const { errors } = await applyTicketChanges(dataAPI, res.data.id, _ticketChanges);
                errors.forEach((message) => enqueueSnackbar(message, { variant: 'error', autoHideDuration: 8000 }));
            }
            setRelatedLoading(false);
            setSyncActive(false);
            setLastUpdate(Date.now());
            return res.data;
        } else if (res.statusCode === 406 || res.statusCode === 400) {
            if (res.data && res.data.message) {
                enqueueSnackbar(res.data.message, { variant: 'error', autoHideDuration: 5000 });
            }
            if (res.data && res.data.errors && res.data.errors.constructor === Array) {
                res.data.errors.forEach((err) => enqueueSnackbar(err.message || err, { variant: 'error' }));
            } else {
                enqueueSnackbar('Error adding user', { variant: 'error', autoHideDuration: 5000 }); // Generic error if no specific messages
            }
        } else {
            enqueueSnackbar('Server error please try again later', { variant: 'error', autoHideDuration: 5000 });
        }

        setRelatedLoading(false);
        setSyncActive(false);
        // Indicate failure if necessary
        return null;
    };

    const showUserAddForm = (ev) => {
        setAddUserFlowOpen(true);
        setAddUserAnchorEl(ev.currentTarget);
        history.push({ search: '?addingUser=true' });
    };

    const addTripUserRef = React.useRef(null);

    const hideAddUserForm = () => {
        setAddUserFlowOpen(false);
        setAddUserAnchorEl(null);
        history.replace({ ...history.location, search: '' });
    };


    const onUserAdd = async (tripUser) => {
        hideAddUserForm();
        if (tripUser?.end_ts) {
            setOwnCheckoutSeen(true);
        }
        const savedUser = await saveChanges(tripUser);

        if (savedUser) {
            if (!savedUser.branchio_link) {
                watchInvitationLink(savedUser.id);
            }
            const updatedStats = await doUpdateUserList();
            if (updatedStats) {
                updateNumberOfTourUsers(updatedStats);
            }
            setPageReset((v) => !v);
            // No need to manually update props.trip.users, RecordListPro handles refresh
        }
    };

    const onClosePreview = () => {
        // Revert check for trip id
        history.replace(formatNewUserManagerPushURL(searchFilterList, recordListFilters, props.trip.id));
        setTourUserId(null);
    };

    const onInvitationLinkClick = (ev, row) => {
        ev.preventDefault();
        if (row.branchio_link) {
            enqueueSnackbar('Link copied to clipboard', { variant: 'success' });
            copyTextToClipboard(row.branchio_link);
            return;
        }
        // The grid may simply be older than the link: watch the booking and refresh the grid
        // when the link is there. Only a booking added in the last few minutes is worth
        // watching for long; for an older one a single look settles it.
        const createdMs = Date.parse(row.created_ts);
        const isRecent = !Number.isNaN(createdMs) && Date.now() - createdMs < 5 * 60 * 1000;
        watchInvitationLink(row.id, isRecent ? undefined : { maxChecks: 1 });
        enqueueSnackbar("The invitation link isn't ready yet. Try again in a few seconds.", { variant: 'info' });
    };

    const onRecordRowClick = React.useCallback((params, ev) => {
        if (ev?.defaultMuiPrevented) {
            return;
        }
        if (!params?.row?.id || !params?.row?.user) {
            return;
        }
        history.replace(formatNewUserManagerPushURL(searchFilterList, recordListFilters, props.trip.id, params.row.id));
        setTourUserId(null);
        setTimeout(() => {
            setTourUserId(params.row.id);
        }, 100);
    }, [history, props.trip.id, recordListFilters, searchFilterList]);


    const hasRenderableUserRow = (row) => !!row?.user;

    const recordListColumns = [
        { field: 'first_name', headerName: 'Full Name', filterable: true, filterOperators: textFilterOperators, sortable: true, minWidth: 150, valueGetter: (p) => p.row?.user?.display_name || '' },
        {
            field: 'role',
            headerName: accessGroupsEnabled() ? 'Legacy role' : 'Role',
            sortable: false,
            filterable: false,
            width: 150,
            renderCell: (p) => hasRenderableUserRow(p.row) ? (
                <RolesCell
                    user={p.row}
                    setSyncActive={setSyncActive}
                    dataAPI={dataAPI}
                    setLastUpdate={setLastUpdate}
                    enqueueSnackbar={enqueueSnackbar}
                    setRelatedLoading={setRelatedLoading}
                    trip={props.trip}
                    roleMap={roleMap}
                    roles={roles_data}
                    finalizeLogin={finalizeLogin}
                />
            ) : null,
        },
        {
            field: 'agroups',
            headerName: 'Access Groups',
            sortable: false,
            filterable: false,
            width: 150,
            renderCell: (p) => hasRenderableUserRow(p.row) ? <AccessGroupsGridCell row={p.row.user} /> : null,
        },
        { field: 'email', headerName: 'Email', sortable: true, filterable: true, filterOperators: textFilterOperators, flex: 0.75, maxWidth: 400, valueGetter: (p) => p.row?.user?.email || '' },
        { field: 'phone', headerName: 'Phone', sortable: true, filterable: true, filterOperators: textFilterOperators, flex: 0.5, maxWidth: 200, valueGetter: (p) => p.row?.user?.phone || '' },
        // CP-8349: a guide group's travel dates are synthetic (and the column's
        // "past" disable would read as expired), so the column doesn't exist there
        // at all -- default visibility alone is overridable from the columns panel.
        ...(props.trip.is_staff_chat_group ? [] : [{
            field: 'date',
            headerName: 'Travel Date',
            sortable: false,
            filterable: true,
            width: 220,
            filterOperators: [
                {
                    label: 'is in range',
                    value: 'dateRange',
                    getApplyFilterFn: () => null, // server-side only
                    InputComponent: DateRangeFilterPanel,
                },
            ],
            renderCell: (p) => hasRenderableUserRow(p.row) ? (
                <DateCell
                    isSmallScreen={isSmallScreen}
                    tourUserDate={p.row.date}
                    user={p.row}
                    setSyncActive={setSyncActive}
                    dataAPI={dataAPI}
                    setLastUpdate={setLastUpdate}
                    enqueueSnackbar={enqueueSnackbar}
                    setRelatedLoading={setRelatedLoading}
                    trip={props.trip}
                />
            ) : null,
        }]),
        // CP-8376: omitted entirely when no booking on the tour owns a checkout.
        // Hiding it in the columns panel is not enough -- that panel can turn it
        // back on, and an empty column on a day tour is noise.
        ...(showCheckoutColumn ? [{
            field: 'checkout_ts',
            headerName: 'Check-out',
            sortable: false,
            filterable: false,
            width: 220,
            // A string, not type:'dateTime'. A v6 dateTime column throws on a
            // non-Date and blanks the whole dashboard (CP-8299). Same format
            // and clock as the edit panel's Check-out picker ('LLL', tour zone).
            valueGetter: (p) => (p.row.checkout_ts ? checkoutPickerMoment(p.row.checkout_ts, props.trip.start_timezone).format('LLL') : ''),
        }] : []),
        {
            field: 'integration',
            headerName: 'Booking System',
            sortable: true,
            filterable: true,
            filterOperators: textFilterOperators,
            width: 220
        },
        {
            field: 'created_ts',
            headerName: 'Created at',
            sortable: true,
            filterable: false,
            width: 220,
            // Revert type and valueGetter change
            valueGetter: (p) => moment.utc(p.row.created_ts),
            valueFormatter: (p) => p.value.format('MMM DD, YYYY HH:mm:ss Z'),
        },
        {
            field: 'updated_ts',
            headerName: 'Updated at',
            sortable: true,
            filterable: false,
            width: 220,
            // Revert type and valueGetter change
            valueGetter: (p) => moment.utc(p.row.updated_ts),
            valueFormatter: (p) => p.value.format('MMM DD, YYYY HH:mm:ss Z'),
        },
        {
            field: 'booking_ts',
            headerName: 'Booking date',
            sortable: true,
            filterable: false,
            width: 220,
            valueGetter: (p) => p.row.booking_ts ? moment.utc(p.row.booking_ts) : null,
            valueFormatter: (p) => p.value ? p.value.format('MMM DD, YYYY HH:mm:ss Z') : '',
        },
        { field: 'lang', headerName: 'Language', sortable: false, filterable: true, filterOperators: textFilterOperators, flex: 0.5, valueGetter: (p) => p.row?.user?.lang || '' },
        { field: 'departure', headerName: 'Departure', sortable: false, filterable: false, width: 100, valueGetter: (p) => p.row.departure?.name },
        // The operator's code for the departure INSTANCE, next to the time-of-day
        // 'Departure' tag above -- two same-date/time departures differ only here.
        // sortable: the server whitelists departure_key in GRID_FILTER_ORDERING.
        { field: 'departure_key', headerName: 'Departure code', sortable: true, filterable: false, width: 170, valueGetter: (p) => p.row.departure_key || '' },
        { field: 'deep_link', headerName: "Deep link", sortable: false, filterable: false, valueGetter: (p) => p.row.branchio_link },
        {
            field: 'tags',
            headerName: 'Tags',
            sortable: false,
            filterable: false,
            // width: 10,
            flex: 1,

            renderCell: (p) => hasRenderableUserRow(p.row) ? (
                <TagCell
                    user={p.row}
                    setTourUserId={setTourUserId}
                    recordListFilters={recordListFilters}
                    searchFilterList={searchFilterList}
                    setSyncActive={setSyncActive}
                    dataAPI={dataAPI}
                    setLastUpdate={setLastUpdate}
                    enqueueSnackbar={enqueueSnackbar}
                    setRelatedLoading={setRelatedLoading}
                    trip={props.trip}
                />
            ) : null,
        },
        // Not filterable: the toolbar's Booking state select already sends booking_state, and a
        // second, column filter on it could only repeat that state or empty the grid (CP-7550).
        { field: 'booking_state', headerName: 'Booking state', sortable: true, filterable: false, flex: 0.5, valueGetter: (p) => BOOKING_STATES[p.row.booking_state] },
        { field: 'checkin_source', headerName: 'Check-in source', sortable: true, filterable: true, type: 'singleSelect', valueOptions: checkinSourceOptions, flex: 0.5, valueFormatter: (p) => typeof CHECKIN_SOURCES[p.value] !== "undefined" ? CHECKIN_SOURCES[p.value] : 'Not pre-checked-in' },
        { field: 'precheckin_status', headerName: 'Pre-check-in', sortable: false, filterable: false, flex: 0.5, type: 'singleSelect', valueOptions: precheckinStatusesOptions, valueFormatter: (p) => PRECHECKIN_STATUSES[p.value] },
        { field: 'survey_state', headerName: 'Survey', sortable: true, filterable: true, type: 'singleSelect', valueOptions: surveyStateOptions, flex: 0.5, valueFormatter: (p) => SURVEY_STATES[p.value] },
        { field: 'mytrips_display', headerName: 'My Trips', sortable: true, filterable: true, type: 'boolean', flex: 0.5, valueGetter: (p) => p.row.mytrips_display },
        { field: 'exclude_from_chat', headerName: 'Chat disabled', sortable: true, filterable: true, type: 'boolean', flex: 0.5, valueGetter: (p) => p.row.exclude_from_chat },
        { field: 'exclude_from_group_chat', headerName: 'Group Chat disabled', sortable: true, filterable: true, type: 'boolean', flex: 0.5, valueGetter: (p) => p.row.exclude_from_group_chat },
        { field: 'order_ref', headerName: 'Booking ID', sortable: true, filterable: false, flex: 0.5, valueGetter: (p) => p.row.order_ref },
        { field: 'voucher', headerName: 'Voucher', sortable: false, filterable: false, flex: 0.5, renderCell: (p) => (p.row.voucher ? <Link href={p.row.voucher.file} target="_blank">{p.row.voucher.name}</Link> : '') },
        { field: 'custom_id', headerName: 'Internal booking ID', sortable: true, filterable: false, flex: 0.5, valueGetter: (p) => p.row.custom_id },
        { field: 'affiliate_ext_id', headerName: 'Affiliate booking ID', sortable: false, filterable: false, flex: 0.5, valueGetter: (p) => p.row.affiliate_ext_id },
        { field: 'supplier_ref', headerName: 'Supplier reference', sortable: false, filterable: false, flex: 0.5, valueGetter: (p) => p.row.supplier_ref || p.row.tag_context?.supplier_reference },
        { field: 'reseller_ref', headerName: 'Reseller reference', sortable: false, filterable: false, flex: 0.5, valueGetter: (p) => p.row.reseller_ref || p.row.tag_context?.reseller_reference },
        {
            field: 'people_count',
            headerName: 'Passenger count',
            sortable: true,
            filterable: false,
            flex: 0.5,
            type: 'number',
            valueGetter: (p) => p.row.people_count ?? p.row.tag_context?.people_count ?? null,
        },
        {
            field: 'passenger_breakdown',
            headerName: 'Passenger breakdown',
            sortable: false,
            filterable: false,
            flex: 1,
            minWidth: 160,
            valueGetter: (p) => p.row.passenger_breakdown || '',
        },
        {
            field: 'is_app_installed',
            headerName: 'App installed',
            type: 'boolean',
            filterable: true,
            flex: 0.3,
            renderCell: (p) => {
                if (!p.row?.user?.is_app_installed) {
                    return 'No';
                }
                const versionText = formatLatestAppVersionsDisplay(p.row?.user?.latest_app_versions);
                return versionText || 'Yes';
            },
        },
        { field: 'location_status', headerName: 'Location status', filterable: true, type: 'singleSelect', valueOptions: locationOptions, flex: 0.5, valueGetter: (p) => +p.row?.user?.location_status, valueFormatter: (p) => LOCATION_STATUS[p.value] },
        { field: 'notifications_status', headerName: 'Notifications status', filterable: true, type: 'singleSelect', valueOptions: notificationsOptions, flex: 0.5, valueGetter: (p) => p.row?.user?.notifications_status, valueFormatter: (p) => p.value ? 'Enabled' : 'Disabled' },
        {
            field: 'latest_position', headerName: 'Last location reported', type: 'dateTime', sortable: true, filterable: false, flex: 0.5,
            // Revert valueGetter change
            valueGetter: (p) => p.row?.user?.latest_position ? moment(p.row?.user?.latest_position.timestamp) : null,
            valueFormatter: (p) => p.value ? p.value.format('MMMM DD, YYYY HH:mm:ss Z') : 'Never'
        },
        { field: 'int_ids', headerName: 'Internal IDs', sortable: false, filterable: false, flex: 0.5, valueGetter: (p) => `${p.row.id}/${p.row.itinerary}/${p.row.public_id}` },
        {
            field: 'main_booking', headerName: 'Main booking', sortable: false, filterable: false, flex: 0.5,
            renderCell: (p) => (p.row.main_booking ? <Link href={`/trip/${props.trip.id}/users/manager/${p.row.main_booking?.id}`} target="_blank">{p.row.main_booking?.display_name}</Link> : null), // Added check for main_booking existence
        },
        {
            field: 'create_source', headerName: 'Registration method', type: 'singleSelect', sortable: true, filterable: true, valueOptions: registrationMethods,
            valueGetter: (p) => (p.row?.create_source),
            valueFormatter: (p) => (SOURCES[+p.value] || 'Unknown'),
        },
        // Revert update_source changes
        {
            field: 'update_source', headerName: 'Update method', type: 'singleSelect', sortable: true, filterable: true, valueOptions: registrationMethods,
            valueGetter: (p) => p.row.update_source,
            valueFormatter: (p) => SOURCES[+p.value] || 'Unknown'
        },
        {
            field: 'pickup_time', headerName: 'Pickup time', sortable: false, filterable: false, flex: 0.5, renderCell: (p) => (
                p.row.tag_context?.pickupDateTime ? moment.utc(p.row.tag_context.pickupDateTime).format("h:mm a") : null
            )
        },
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            filterable: false,
            // flex: 1,
            minWidth: 160,
            renderCell: (p) => hasRenderableUserRow(p.row) ? (
                <Grid container justifyContent="flex-end" alignItems="center" spacing={1} p={1}>
                    <Grid item style={{ cursor: 'pointer' }}>
                        <Tooltip title="Edit user info">
                            <Link
                                href={formatNewUserManagerPushURL(searchFilterList, recordListFilters, props.trip.id, p.row.id)}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    history.replace(formatNewUserManagerPushURL(searchFilterList, recordListFilters, props.trip.id, p.row.id));
                                    setTourUserId(null);

                                    setTimeout(() => {
                                        setTourUserId(p.row.id);
                                    }, 100);
                                }}
                            >
                                <EditIcon color="primary" />
                            </Link>
                        </Tooltip>
                    </Grid>
                    <Grid item style={{ cursor: 'pointer' }}>
                        <Tooltip title="View user profile">
                            <Link
                                href={`/user/${p.row.user?.id}`}
                                target="_blank"
                                onClick={(ev) => {
                                    // Keep the row click from also opening the Edit User Registration panel
                                    ev.stopPropagation();
                                }}
                            >
                                <AccountCircleIcon color="primary" />
                            </Link>
                        </Tooltip>
                    </Grid>

                    <Grid item style={{ cursor: 'pointer' }}>
                        <Tooltip title="Copy invitation link">
                            <LinkIcon
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    onInvitationLinkClick(ev, p.row);
                                }}
                            />
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <DeleteIconButton
                            title="Remove user from trip"
                            perm="tour_participant.delete"
                            fontSize="medium"
                            sx={{ p: 0 }}
                            onClick={(ev) => {
                                ev.stopPropagation();
                                onDeleteUserList([p.row.id], p.row);
                            }}
                        />
                    </Grid>
                </Grid>
            ) : null,
        },
    ];

    const onColumnOrderChange = React.useCallback((params) => {
        const field = params.column?.field;
        if (!field || field === GROUPING_COLUMN_FIELD || field.startsWith('__tree_data_group__')) {
            return;
        }

        const baseFields = (
            isGroupedByMainBooking
                ? recordListColumns.filter((col) => col.field !== 'main_booking')
                : recordListColumns
        ).map((col) => col.field);

        setColumnOrder((prev) => {
            let order = prev.length ? [...prev] : baseFields;
            const oldIndex = order.indexOf(field);
            let targetIndex = params.targetIndex;
            // Grouped view: grouping column is pinned at index 1 by DataGrid
            if (isGroupedByMainBooking && targetIndex > 0) {
                targetIndex -= 1;
            }

            if (oldIndex === -1) {
                order.splice(targetIndex, 0, field);
            } else {
                order.splice(oldIndex, 1);
                if (targetIndex > oldIndex) targetIndex -= 1;
                order.splice(targetIndex, 0, field);
            }

            order = sanitizeColumnOrder(order);
            try { localStorage.setItem(COLUMN_ORDER_KEY, JSON.stringify(order)); } catch {}
            return order;
        });
    }, [isGroupedByMainBooking]);

    // Bake saved widths and column order into definitions so DataGridPro never resets them.
    const withSavedWidths = (cols) => cols.map((col) => {
        const w = columnWidths[col.field];
        if (!w) return col;
        const { flex: _removed, ...rest } = col;
        return { ...rest, width: w };
    });

    const applyColumnOrder = (cols, order) => {
        if (!order?.length) return cols;
        const byField = Object.fromEntries(cols.map((col) => [col.field, col]));
        const ordered = [];
        const seen = new Set();
        for (const field of order) {
            if (byField[field]) {
                ordered.push(byField[field]);
                seen.add(field);
            }
        }
        for (const col of cols) {
            if (!seen.has(col.field)) ordered.push(col);
        }
        // A saved order predates Check-out, so the append above parks it after
        // Action. Sit it next to Travel Date until the user moves it.
        if (byField.checkout_ts && !(order || []).includes('checkout_ts')) {
            const current = ordered.findIndex((col) => col.field === 'checkout_ts');
            const afterDate = ordered.findIndex((col) => col.field === 'date');
            if (current >= 0 && afterDate >= 0 && current !== afterDate + 1) {
                const [col] = ordered.splice(current, 1);
                const dateAt = ordered.findIndex((c) => c.field === 'date');
                ordered.splice(dateAt + 1, 0, col);
            }
        }
        return ordered;
    };

    const effectiveRecordListColumns = withSavedWidths(
        applyColumnOrder(
            isGroupedByMainBooking
                ? recordListColumns.filter((col) => col.field !== 'main_booking')
                : recordListColumns,
            columnOrder
        )
    );

    // Batch operations
    const onSelectionModelChange = (ids) => {
        setSelectedIds(ids);
        setTourUserId(null);
        replaceUserManagerPathPreservingGridPagination(
            formatNewUserManagerPushURL(searchFilterList, recordListFilters, props.trip.id)
        );
    };

    const deleteUsers = () => {
        onDeleteUserList(selectedIds);
    };

    // Revert nonRequiredTripAssociatedTagsIds memoization
    const nonRequiredTripAssociatedTagsIds = props.trip.tag_categories
        .filter((cat) => cat.min_tags === 0 && cat.category.code !== 'departure')
        .map((cat) => {
            return cat.category.id;
        });


    const addTags = () => {
        setShowActionForm(true);
        setBatchActionType('ADD_TAGS');
    };

    const removeTags = () => {
        setShowActionForm(true);
        setBatchActionType('REMOVE_TAGS');
    };

    const addObservedUsers = () => {
        setShowActionForm(true);
        setBatchActionType('ADD_OBSERVED_USERS');
    };

    const removeObservedUsers = () => {
        setShowActionForm(true);
        setBatchActionType('REMOVE_OBSERVED_USERS');
    };

    const [batchChangeOwnerOpen, setBatchChangeOwnerOpen] = React.useState(false);
    const openBatchChangeOwner = () => setBatchChangeOwnerOpen(true);
    const closeBatchChangeOwner = () => setBatchChangeOwnerOpen(false);
    const onBatchOwnerChanged = () => {
        setSelectedIds && setSelectedIds([]);
        setLastUpdate(Date.now());
    };

    const onSelectAll = selectAll;
    const onDeselectAll = deselectAll;

    const recordListLocaleText = React.useMemo(() => ({
        footerRowSelected: () => (
            selectedIds.length === 1
                ? '1 row selected'
                : `${selectedIds.length} rows selected`
        ),
    }), [selectedIds.length]);

    const onExportList = async () => {
        try {
            setSyncActive(true);
            const tagIds = recordListFilters.tagSearchFilters || [];
            const excludeTagIds = recordListFilters.tagExcludeFilters || [];

            const params = {
                urlSuffix: `export/?tour_id=${props.trip.id}&tag_ids=${tagIds.join(',')}&exclude_tag_ids=${excludeTagIds.join(',')}`,
            };

            const res = await dataAPI(GET_ONE, resource, params);
            const body = await res.response.blob();
            const url = window.URL.createObjectURL(body);

            let filename = '';
            const disposition = res.headers['Content-Disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/["']/g, '');
                }
            }
            if (!filename || filename.length <= 0) {
                filename = `tour_users_${props.trip.id}.csv`;
            }

            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            setTimeout(() => {
                document.body.removeChild(a);
            }, 100);
        } catch (error) {
            console.error('onExportList: Error exporting users list:', error);
            enqueueSnackbar('Error exporting users list', { variant: 'error' });
        } finally {
            setSyncActive(false);
        }
    };


    //Check for existing record list filters
    // Revert useEffect logic for initializing filters
    React.useEffect(() => {
        if (routeParamsAPIFilters && routeParamsAPIFilters.constructor === Object && Object.keys(routeParamsAPIFilters).length > 0) {
            if (routeParamsAPIFilters.searchFilterList) {
                setSearchFilterList(routeParamsAPIFilters.searchFilterList);
            }
            if (routeParamsAPIFilters.recordListFilters) {
                setRecordListFilters(routeParamsAPIFilters.recordListFilters);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    //Update recordList filters upon search filters update
    React.useEffect(() => {
        let userSearchFiltersHolder = searchFilterList.filter((f) => f.type === 'user');
        userSearchFiltersHolder = userSearchFiltersHolder.map((f) => f.id);
        const tagFilters = searchFilterList.filter((f) => f.type === 'tag');
        const tagSearchFiltersHolder = tagFilters.filter((f) => !f.exclude).map((f) => f.id);
        const tagExcludeFiltersHolder = tagFilters.filter((f) => f.exclude).map((f) => f.id);

        let roleSearchFiltersHolder = searchFilterList.filter((f) => f.type === 'role');
        roleSearchFiltersHolder = roleSearchFiltersHolder.map((f) => f.id);

        if (roleSearchFiltersHolder.length === 0) {
            roleSearchFiltersHolder = null;
        }

        setRecordListFilters((prevState) => ({
            ...prevState,
            tagSearchFilters: tagSearchFiltersHolder,
            tagExcludeFilters: tagExcludeFiltersHolder,
            userSearchFilters: userSearchFiltersHolder,
            roleFilter: roleSearchFiltersHolder,
        }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFilterList]);


    // //Update current URL path based on selected recordList and searchList filters
    // Revert useEffect logic for updating URL
    React.useEffect(() => {
        let existing_rl_filters = { ...recordListFilters };
        let existing_search_filters = searchFilterList;

        let clean_url_record_list_object = { searchFilterList: existing_search_filters, recordListFilters: existing_rl_filters };

        if (searchFilterList.length === 0) {
            delete clean_url_record_list_object.searchFilterList;
        }
        if (recordListFilters?.tagSearchFilters?.length === 0) {
            delete clean_url_record_list_object.recordListFilters.tagSearchFilters;
        }
        if (recordListFilters?.userSearchFilters?.length === 0) {
            delete clean_url_record_list_object.recordListFilters.userSearchFilters;
        }

        if (!recordListFilters?.roleFilter || recordListFilters?.roleFilter?.length === 0) {
            delete clean_url_record_list_object.recordListFilters.roleFilter;
        }

        if (recordListFilters?.bookingState == BOOKING_STATE_BOOKED) {
            delete clean_url_record_list_object.recordListFilters.bookingState;
        }

        if (recordListFilters?.agroups?.length === 0 || !recordListFilters.agroups) {
            delete clean_url_record_list_object.recordListFilters.agroups;
        }

        if (!recordListFilters?.dateStartFilter) {
            delete clean_url_record_list_object.recordListFilters.dateStartFilter;
        }
        if (!recordListFilters?.dateEndFilter) {
            delete clean_url_record_list_object.recordListFilters.dateEndFilter;
        }
        if (!recordListFilters?.departureTimeStart) {
            delete clean_url_record_list_object.recordListFilters.departureTimeStart;
        }
        if (!recordListFilters?.departureTimeEnd) {
            delete clean_url_record_list_object.recordListFilters.departureTimeEnd;
        }

        if (Object.keys(clean_url_record_list_object.recordListFilters || {}).length === 0) {
            delete clean_url_record_list_object.recordListFilters;
        }

        let new_url = `/trip/${props.trip.id}/users/manager`;

        if (tourUserId) {
            const searchParams = new URLSearchParams(history.location.search);
            const page = searchParams.get('page');
            const pageSize = searchParams.get('pageSize');

            new_url += `/${tourUserId}`;
            if (Object.keys(clean_url_record_list_object).length > 0) {
                new_url += `/${JSON.stringify(clean_url_record_list_object)}`;
            }

            const newSearchParams = new URLSearchParams();
            if (page) newSearchParams.set('page', page);
            if (pageSize) newSearchParams.set('pageSize', pageSize);

            const searchString = newSearchParams.toString();
            if (searchString) {
                new_url += `?${searchString}`;
            }
        } else {
            if (Object.keys(clean_url_record_list_object).length > 0) {
                new_url += `/${JSON.stringify(clean_url_record_list_object)}`;
            }
            if (history.location.search) {
                new_url += history.location.search;
            }
        }

        const currentUrl = history.location.pathname + history.location.search;
        if (currentUrl !== new_url) {
            history.replace(new_url);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordListFilters, searchFilterList, tourUserId, props.trip?.id, history.location.search]);


    return (
        <div className={clsx(classes.root, fixedListLayout && classes.rootFixedLayout)}>
            <FixedLinearProgress visibility={syncActive} />
            <PageMeta title="Trip users" />
            {confirmationDialogAction ? (
                <ConfirmationDialog
                    classes={{ paper: classes.paper }}
                    keepMounted
                    onCancel={confirmationDialogCancel}
                    onConfirm={confirmationDialogConfirm}
                    title={ConfirmationUserDialogText[confirmationDialogAction].title}
                    okButtonText={ConfirmationUserDialogText[confirmationDialogAction].okButtonText}
                    cancelButtonText={ConfirmationUserDialogText[confirmationDialogAction].cancelButtonText}
                    destructive={ConfirmationUserDialogText[confirmationDialogAction].destructive}
                    open={!!confirmationDialogAction}
                >
                    {confirmationDialogAction === 'delete_user' ? `Do you really want to remove ${selectedUserToDeleteDetails?.user?.display_name || 'User'} from ${props?.trip?.name}?` : ConfirmationUserDialogText[confirmationDialogAction]?.body}
                </ConfirmationDialog>
            ) : null}
            <ConfirmationDialog
                classes={{ paper: classes.paper }}
                keepMounted
                open={resetGridLayoutDialogOpen}
                onCancel={() => setResetGridLayoutDialogOpen(false)}
                onConfirm={confirmResetGridLayout}
                title="Reset table layout"
                okButtonText="Reset"
                cancelButtonText="Cancel"
            >
                Reset column visibility, order, widths, and sorting to defaults?
            </ConfirmationDialog>
            {/* Render UserListToolbar outside RecordListPro */}
            <Grid container>
                <UserListToolbar
                    resource={resource}
                    onDeleteUser={onDeleteUserList}
                    showUserAddForm={showUserAddForm}
                    tourUserId={tourUserId}
                    setLastUpdate={setLastUpdate}
                    lastUpdate={lastUpdate}
                    trip={props.trip}
                    tourUserRoles={tourUserRoles} // Pass tourUserRoles again
                    numberOfTourUsers={numberOfTourUsers}
                    setSearchFilterList={setSearchFilterList}
                    searchFilterList={searchFilterList}
                    addUserFlowOpen={addUserFlowOpen}
                    setRecordListFilters={setRecordListFilters}
                    recordListFilters={recordListFilters}
                    selectedIds={selectedIds}
                    deleteUsers={deleteUsers}
                    addTags={addTags}
                    removeTags={removeTags}
                    addObservedUsers={addObservedUsers}
                    removeObservedUsers={removeObservedUsers}
                    openBatchChangeOwner={openBatchChangeOwner}
                    syncActive={syncActive}
                    // setActivePopperState={props.setActivePopperState} // This was likely correctly removed before
                    nonRequiredTripAssociatedTagsIds={nonRequiredTripAssociatedTagsIds}
                    // setRecordListPage={setRecordListPage}
                    setRecordListQuery={setRecordListQuery}
                    onExportList={onExportList}
                    onDocumentExport={openBookingExport}
                    onSelectAll={onSelectAll}
                    onDeselectAll={onDeselectAll}
                />
                <EntityExportDialog
                    open={bookingExportOpen}
                    onClose={() => setBookingExportOpen(false)}
                    entity="booking"
                    initialFormat={bookingExportFormat}
                    exportDocument={exportBookingDocument}
                    exporting={bookingExporting}
                    selectionLabel={selectedIds?.length
                        ? `${selectedIds.length} selected bookings`
                        : "all of this trip's bookings matching the current filters"}
                />
            </Grid>
            <Grid container alignItems="center">
                <Grid item xs={1}>
                    {showActionForm && (
                        <BatchActionsMenu
                            trip={props.trip}
                            batchActionType={batchActionType}
                            setBatchActionType={setBatchActionType}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            setRelatedLoading={setRelatedLoading}
                            setSyncActive={setSyncActive}
                            setShowActionForm={setShowActionForm}
                            setLastUpdate={setLastUpdate}
                            nonRequiredTripAssociatedTagsIds={nonRequiredTripAssociatedTagsIds}
                        />
                    )}
                    {hasPerm('ops', 'change_booking_user') && (
                        <BatchChangeBookingOwnerDialog
                            open={batchChangeOwnerOpen}
                            onClose={closeBatchChangeOwner}
                            selectedIds={selectedIds}
                            onChanged={onBatchOwnerChanged}
                        />
                    )}
                    <Popper open={addUserFlowOpen} style={{ zIndex: 1 }} anchorEl={addUserAnchorEl} onClose={hideAddUserForm} placement="bottom-start" disablePortal={false}>
                        <ClickAwayListener
                            onClickAway={() => {
                                addTripUserRef.current ? addTripUserRef.current.requestClose() : hideAddUserForm();
                            }}
                        >
                            <Paper className={classes.addTripUserPaperWrapper}>
                                <AddTripUser ref={addTripUserRef} isStaff={false} trip={props.trip} isExisting={false} apiFilters={[{ field: 'trip', value: props.trip.id }]} onAdd={onUserAdd} onCancel={hideAddUserForm} syncActive={syncActive} isSmallScreen={isSmallScreen} />
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                </Grid>
            </Grid>
            <Grid xs={12} item container direction="row" className={fixedListLayout ? classes.listRowFixedLayout : undefined}>
                                {(() => {
                    const shouldHideList = !!(isSmallScreen && tourUserId);
                    
                    if (shouldHideList) {
                        return <div key="mobile-hidden" />;
                    }
                    
                    return (
                        <Grid item xs={cols} className={clsx(classes.recordListWrapper, fixedListLayout && classes.recordListWrapperFixedLayout)} mx={isSmallScreen ? 0 : 0} px={isSmallScreen ? 1 : 0} style={{ position: 'relative' }}>
                            <SelectAllBanner
                                selectedIds={selectedIds}
                                selectAllMeta={selectAllMeta}
                                onSelectAll={selectAll}
                                onDeselectAll={deselectAll}
                                loading={selectAllLoading}
                            />
                            <RecordListPro
                                className={classes.recordList}
                                resource={resource}
                                rowsPerPageOptions={[25, 50, 100, 250, 500]}
                                urlSuffix={`?tour_id=${props.trip.id}`}
                                extraQueryParams={recordListExtraQueryParams}
                                // Pass memoized apiFilters
                                apiFilters={apiFiltersForRecordList}
                                disableSelectionOnClick={true}
                                checkboxSelection={true}
                                isRowSelectable={(params) => !isGroupedByMainBooking || params.row?._isGroupMain !== false}
                                selectionModel={selectedIds}
                                rowSelectionModel={selectedIds}
                                keepNonExistentRowsSelected={true}
                                localeText={recordListLocaleText}
                                relatedLoading={relatedLoading}
                                onRowClick={onRecordRowClick}
                                onRowSelectionModelChange={onSelectionModelChange}
                                columns={effectiveRecordListColumns}
                                sortModel={sortModel}
                                onSortModelChange={onSortModelChange}
                                onColumnOrderChange={onColumnOrderChange}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={onColumnVisibilityModelChange}
                                onColumnWidthChange={onColumnWidthChange}
                                noBorder={true}
                                slots={{ columnsPanel: TripUserColumnsPanel }}
                                slotProps={{
                                    panel: { sx: { maxWidth: 'none', '& .MuiDataGrid-filterForm': { flexWrap: 'wrap', gap: 1, '& .MuiDataGrid-filterFormValueInput': { minWidth: 320 } } } },
                                    columnsPanel: {
                                        onResetClick: () => setResetGridLayoutDialogOpen(true),
                                    },
                                }}
                                query={recordListQuery}
                                deps={lastUpdate}
                                pageReset={pageReset}
                                setIsLoading={setRelatedLoading}
                                transformRows={transformRecordListRows}
                                {...(isGroupedByMainBooking ? {
                                    treeData: true,
                                    getTreeDataPath: (row) => row._treePath || [String(row.id)],
                                    groupingColDef: groupedTreeColumn,
                                    defaultGroupingExpansionDepth: 0,
                                    mobileRowComponent: GroupedMobileUserRow,
                                } : {})}
                                onRemoveUserFromTrip={(userId) => {
                                    onDeleteUserList([userId]);
                                }}
                                skipDeleteConfirmation={true}
                                searchFilterList={searchFilterList}
                                recordListFilters={recordListFilters}
                                trip={props.trip}
                                setTourUserId={setTourUserId}
                                key={`recordlist-${props.trip.id}-${isGroupedByMainBooking ? 'grouped' : 'flat'}`}
                            />
                        </Grid>
                    );
                })()}
                {tourUserId ? (
                    <Grid item xs={12 - cols} >
                        <TripUserPreview key={tourUserId} resource={resource} id={tourUserId} onClose={onClosePreview} onDelete={onDeleteUserList} onSave={saveChanges} onOwnCheckoutSeen={() => setOwnCheckoutSeen(true)} trip={props.trip} isSmallScreen={isSmallScreen} setLastUpdate={setLastUpdate} tourUserId={tourUserId} />
                    </Grid>
                ) : null}
            </Grid>
        </div>
    );
};

// Add PropTypes for validation
UserManager.propTypes = {
    trip: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        is_bespoke: PropTypes.bool,
        user_stats: PropTypes.object,
        tag_categories: PropTypes.arrayOf(PropTypes.object),
        // users: PropTypes.array, // users array might not be needed directly if RecordListPro handles fetching
    }).isRequired,
    // setTrip: PropTypes.func.isRequired, // Might not be needed if RecordListPro handles data refresh
    // setActivePopperState: PropTypes.func, // This prop seems unused in the context
};

// Helper function definitions (assuming they exist elsewhere)
// function formatDateFilters(dateStartFilter, dateEndFilter) { ... }
// function checkIfURLDataIsUserId(data) { ... }
